import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FindCareGetParam } from '../../../../core/models/find-care/findcare-get-param';
import { FindCareTeamModel } from '../../../../core/models/find-care/findcare-team-model';
import { CommonService } from '../../../../core/services/v2/common.service';
import { GeoLocationService } from '../../../../core/services/v2/geolocation.service';
import { UtilsService } from '../../../../core/services/v2/utils.service';
import { WindowLoaderService } from '../../window-loader/window-loader.service';
import * as _ from 'lodash';
import { GoogleMapMarker, MapLocation } from '../../../../core/models/google-map-marker';
import { UserService } from '../../../../core/services/v2/user.service';
import { AppyUser } from '../../../../core/model/v2/AppyUser';
import { PatientService } from '../../../../core/services/v2/patient.service';
import { SpecialityCategory } from '../../../../core/models/find-care/speciality-category';
import { Speciality, SpecialitySubCategory } from '../../../../core/models/find-care/speciality-sub-category';
import { query } from '@angular/animations';
//import { google } from '@agm/core/services/google-maps-types';
declare const google: any;

@Component({
  selector: 'app-find-care-team',
  templateUrl: './find-care-team.component.html',
  styleUrls: ['./find-care-team.component.scss']
})
export class FindCareTeamComponent implements OnInit {
  categoryId: number;
  subCategoryId: number;
  specializationId: number;
  latitude: any;
  longitude: any;
  patientId: number;
  findCareTeams: FindCareTeamModel[];
  findCareTeamsFiltered: FindCareTeamModel[];
  currentLocation: MapLocation;
  allCordinates: any;
  selectedDistance: number;
  patientZipCode: "";
  planid: string;
  planName: string;
  careTypeList = [
    { value: "All", label: "All" },
    { value: "Physician", label: "Physician" },
    { value: "Medical Professional", label: "Healthcare Professionals" },
    { value: "HealthSystem", label: "Practice/Hospital/Clinic" },
  ];
  distanceList = [
    { value: "1", label: "Within 1 miles" },
    { value: "2", label: "Within 2 miles" },
    { value: "3", label: "Within 3 miles" },
    { value: "5", label: "Within 5 miles" },
    { value: "10", label: "Within 10 miles" },
    { value: "15", label: "Within 15 miles" },
    { value: "25", label: "Within 25 miles" },
    { value: "0", label: "Greater than 25 miles" },
  ];
  sortByList = [
    { value: "0", label: "None" },
    { value: "1", label: "Distance Nearest First" },
    { value: "2", label: "Distance Nearest Last" },
    { value: "3", label: "Ascending (A-Z)" },
    { value: "4", label: "Descending (Z-A)" },
  ];
  filterForm: FormGroup = this.fb.group({
    type: ['All'],
    distance: ['10'],
    inNetwork: ['All'],
    sortBy: ['0'],
    search: [''],
  });
  markers: GoogleMapMarker[] = [];
  openedWindow: number;
  user: AppyUser;
  category: SpecialityCategory;
  subSpecialityName: string;

  constructor(
    private userService: UserService,
    private commonService: CommonService,
    private patientService: PatientService,
    private route: ActivatedRoute,
    private utils: UtilsService,
    private loaderService: WindowLoaderService,
    private locationService: GeoLocationService,
    private fb: FormBuilder,
    private router: Router) { }

  ngOnInit() {
    //let categorySelected = this.distanceList.find(a => a.value == '5');
    //this.filterForm.controls['distance'].setValue(categorySelected.value);
    this.selectedDistance = 10;
    
    this.userService.getUserDetails().subscribe((user) => {
      this.user = user;
      if (this.user.role == 'Patient') {
        this.patientId = this.user.patientId;
      }
      this.bindParamsAndForm();
    });
  }

  bindParamsAndForm() {
    this.categoryId = +this.route.snapshot.queryParams['catId'];
    this.subCategoryId = +this.route.snapshot.queryParams['subCatId'];
    this.specializationId = +this.route.snapshot.queryParams['specId'];
    this.subSpecialityName = this.route.snapshot.queryParams['subSpeciality'];
    this.latitude = +this.route.snapshot.queryParams['lat'];
    this.longitude = +this.route.snapshot.queryParams['lng'];
    this.patientZipCode = this.route.snapshot.queryParams['zipCode'];
    this.planid = this.route.snapshot.queryParams['planid'];
    this.planName = this.route.snapshot.queryParams['planName'];
    if (this.latitude > 0 && this.longitude != 0) {
      this.currentLocation = { lat: this.latitude, lng: this.longitude };
      this.getCategory();
      //this.getFindCareTeams();
    }
    else {
      this.locationService.getPosition().then((pos) => {
        this.currentLocation = { lat: pos.lat, lng: pos.long };
        // this.currentLocation = { lat: 32.897729, lng: -97.029874 };
        console.log(`Positon:${pos.lat} ${pos.long}`);
        this.getCategory();
        //this.getFindCareTeams();
      }).catch((err) => {
        alert('Please enable location and refresh again to get accurate data for this page.');
        this.getCategory();
        //this.getFindCareTeams();
      });
    }

  }

  getCategory() {
    this.commonService.GetSpecialtyCategories(this.categoryId).subscribe(
      (details) => {
        if (details.resultStatus.isSuccess) {
          this.category = details.specialtyCategoriesList[0];
          //this.subCategory = this.category.specialtySubCategoriess.find(x => x.id == this.subCategoryId);
          this.getFindCareTeams();
        }
        else {
          this.utils.showMessageSnackBar(details.resultStatus.message, true);
        }
      },
      (error) => { console.error(error); this.loaderService.hide(); }
    );
  }

  getFindCareTeams() {
    //const getObj: FindCareGetParam = {
    //  //specialityCategoryId: this.categoryId,
    //  //specialitySubCategoryId: this.subCategoryId,
    //  //specializationCategoryId: this.specializationId,
    //  searchTerm: this.subCategory,
    //  latitude: this.currentLocation ? this.currentLocation.lat : 0,
    //  longitude: this.currentLocation ? this.currentLocation.lng : 0,
    //  zipCode: "",
    //  userId: 0,
    //  distance: this.selectedDistance == undefined ? 0 : this.selectedDistance
    //};
    const searchParams = {
      searchTerm: this.subSpecialityName,
      latitude: this.currentLocation ? this.currentLocation.lat : 0,
      longitude: this.currentLocation ? this.currentLocation.lng : 0,
      distance: this.selectedDistance == undefined ? 0 : this.selectedDistance,
      //"zipCode": '',
      userId: this.user.id
    };
    this.loaderService.blockWithLoader(this.commonService.SearchForProvidersByGivenCriteria(searchParams)).subscribe(
      (details) => {
        this.findCareTeams = details;
        this.bindProperties();
      },
      (error) => { console.error(error); this.loaderService.hide(); }
    );
  }

  bindProperties() {
    this.findCareTeamsFiltered = [];
    this.allCordinates = [];
    if (this.findCareTeams && this.findCareTeams.length > 0) {
      this.findCareTeams = this.findCareTeams.map((x, index) => ({ ...x, id: index }));
      let findCareData = this.findCareTeams;
      this.allCordinates = [];
      if (this.currentLocation) {
        for (let i = 0; i < findCareData.length; i++) {
          findCareData[i].distance = (+findCareData[i].distance).toFixed(1); //this.utils.calculateGeoDistance(findCareData[i].latitude, findCareData[i].longitude, this.currentLocation.lat, this.currentLocation.lng, true).toFixed(1);
        }
      }
      this.findCareTeams = findCareData;
      this.findCareTeamsFiltered = this.findCareTeams;
      //this.findCareTeamsFiltered = this.findCareTeamsFiltered.sort(((a, b) => a.isInNetwork < b.isInNetwork ? 1 : -1));

      this.addMarkers(this.findCareTeamsFiltered);
    }
  }

  filterData() {
    const type = this.filterForm.get('type').value;
    const inNetwork = this.filterForm.get('inNetwork').value;
    let search = this.filterForm.get('search').value;
    let data = _.cloneDeep(this.findCareTeams);
    if (type && type != 'All') {
      data = data.filter(x => x.searchType == type || x.npiType == type.toUpperCase());
    }
    if (inNetwork && inNetwork != 'All') {
      if (inNetwork == 'Yes')
        data = data.filter(x => x.isInNetwork == true);
      else
        data = data.filter(x => x.isInNetwork == false);
    }
    if (search && search != '') {
      search = search.toLowerCase();
      data = data.filter(x => x.fullName.toLowerCase().includes(search));
    }

    this.findCareTeamsFiltered = data;


  }
  filterDistance() {
    const distance = this.filterForm.get('distance').value;
    this.selectedDistance = distance;
    if (distance && distance != '') {
      this.getFindCareTeams();
    }
  }

  sortData() {
    const sortBy = this.filterForm.get('sortBy').value;
    if (sortBy && sortBy != '' && sortBy != '0') {
      if (sortBy == '1') {
        this.findCareTeamsFiltered = this.findCareTeamsFiltered.sort(((a, b) => +a.distance > +b.distance ? 1 : -1));
      }
      else if (sortBy == '2') {
        this.findCareTeamsFiltered = this.findCareTeamsFiltered.sort(((a, b) => +a.distance < +b.distance ? 1 : -1));
      }
      else if (sortBy == '3') {
        this.findCareTeamsFiltered = this.findCareTeamsFiltered.sort(((a, b) => a.fullName > b.fullName ? 1 : -1));
      }
      else if (sortBy == '4') {
        this.findCareTeamsFiltered = this.findCareTeamsFiltered.sort(((a, b) => a.fullName < b.fullName ? 1 : -1));
      }
    }
  }

  addMarkers(data: FindCareTeamModel[]) {
    this.markers = [];
    for (let i = 0; i < data.length; i++) {
      const item = data[i];
      let labelCounter = i + 1;
      if (item.latitude != null) {
        this.markers.push(<GoogleMapMarker>{
          id: item.id,
          draggable: false,
          label: labelCounter.toString(),
          lat: item.latitude,
          lng: item.longitude,
          data: item
        })
      }
      else {
        const that = this;
        new google.maps.Geocoder()
          .geocode({ 'address': item.address1 + ', ' + item.city + ', ' + item.state },
            function (results, status) {
              if (status === google.maps.GeocoderStatus.OK) {
                item.latitude = results[0].geometry.location.lat();
                item.longitude = results[0].geometry.location.lng();
                that.markers.push(<GoogleMapMarker>{
                  id: item.id,
                  draggable: false,
                  label: labelCounter.toString(),
                  lat: item.latitude,
                  lng: item.longitude,
                  data: item
                })
              }
            });
      }
    }
  }

  openWindow(id) {
    this.openedWindow = id; // alternative: push to array of numbers
  }

  isInfoWindowOpen(id) {
    return this.openedWindow == id; // alternative: check if id is in array
  }

  gotoFindCare() {
    let queryParams;
    if (this.route.snapshot.queryParams.lat && this.route.snapshot.queryParams.lng && this.route.snapshot.queryParams.zipCode) {
      queryParams = {
        lat: this.route.snapshot.queryParams['lat'] ? this.route.snapshot.queryParams['lat'] : 0,
        lng: this.route.snapshot.queryParams['lng'] ? this.route.snapshot.queryParams['lng'] : 0,
        zipCode: this.route.snapshot.queryParams['zipCode'] ? this.route.snapshot.queryParams['zipCode'] : 0,
      };
    }
    this.router.navigate(['../../findcare'], {
      relativeTo: this.route,
      queryParams: queryParams
    });
  }

  gotoFindCareCategory() {
    let queryParams: any = {
      catId: this.categoryId,
      subCatId: this.subCategoryId,
      specId: this.specializationId
    };

    if (this.route.snapshot.queryParams.lat && this.route.snapshot.queryParams.lng && this.route.snapshot.queryParams.zipCode) {
      queryParams.lat = this.route.snapshot.queryParams['lat'] ? this.route.snapshot.queryParams['lat'] : 0;
      queryParams.lng = this.route.snapshot.queryParams['lng'] ? this.route.snapshot.queryParams['lng'] : 0;
      queryParams.zipCode = this.route.snapshot.queryParams['zipCode'] ? this.route.snapshot.queryParams['zipCode'] : 0;
    }

    this.router.navigate(['../../findcare', this.categoryId], {
      relativeTo: this.route,
      queryParams: queryParams
    });
  }

}
